// extracted by mini-css-extract-plugin
module.exports = {"Header":"Layout_Header__3Mowf","Icon":"Layout_Icon__tGq-T","Body":"Layout_Body__2UkHm"};